import images from "../content/responsiveImages.json";

type ResponsiveImage = { src: string; srcSet: string; width: number; height: number };
const catalog: Record<string, ResponsiveImage> = images;
type ResponsiveImageProps = { src: string; srcSet?: string; width?: number; height?: number; sizes?: string };

export const responsiveImageProps = (source: string, sizes: string): ResponsiveImageProps => {
  const image = catalog[source];
  return image ? { ...image, sizes } : { src: source };
};

// Cover crops on the narrow, tall mobile hero need more pixels than its box width.
export const HOMEPAGE_HERO_SIZES = "(max-width: 760px) 1100px, 100vw";
